<script>
    import { fade,slide,scale } from 'svelte/transition';
    import { flip } from 'svelte/animate';
    import { _  } from 'svelte-i18n';
    import { onMount , createEventDispatcher} from 'svelte';

    let dispatch = createEventDispatcher();

    export let popupActive = false;
    export let approveActive = false;
    const close = () => {
        dispatch('ClosePopup','');
    }
    const approve = () => {
        dispatch('ApprovePopup','');
    }
    
  </script>
  <style>
   
    button {
        padding: 10px 20px;
        background-color: #FFCF01;
        color: black;
        border: none;
        border-radius: 40px;
        cursor: pointer;
        font-weight: bold;
        font-size: 16px;
        margin:5px 0;
        text-decoration: none;
    }
    button.close {
        color: #fff;
        background: #000;
    }
  </style>
  {#if popupActive}
  <div class="popup" in:fade out:fade|local>
    <div class="popup-box">
      <div class="popup-close" on:click={close}></div>
      <div class="popup-v"></div>
      <slot name="title"></slot>
      <slot name="content"></slot>
      {#if approveActive}
      <button type="submit" class="popup-button" on:click={approve}>
        {$_('store.approve')}
      </button>
      {/if}
      <button type="submit" class="popup-button close" on:click={close}>
        {$_('store.close')}
      </button>
    </div>
  </div>
  {/if}